import React from 'react';
import { Routes, Route } from 'react-router-dom';
import FacilityThemeProviders from './styles/FacilityThemeProviders';
import Navbar from './components/Navbar';
import Customers from './pages/Customers';
import Orders from './pages/Orders';
import Products from './pages/Products';
import OrderingDashboard from './pages/OrderingDashboard';
import APIOrdering from './pages/APIOrdering';
import ReceivingDashboard from './pages/ReceivingDashboard';
import APIReceiving from './pages/APIReceiving';
import Lines from './pages/Lines';
import NewOrder2 from './pages/NewOrder2';
import QuickOrder from './pages/QuickOrder';
import QuickOrderCheckout from './pages/QuickOrderCheckout';
import OrderConfirmation from './pages/OrderConfirmation';
import PrintList from './pages/PrintList';
import PrintList2 from './pages/PrintList2';
import ScreenList from './pages/ScreenList';
import ScreenList2 from './pages/ScreenList2';
import FilmList from './pages/FilmList';
import Invoicing from './pages/Invoicing';
import Archive from './pages/Archive';
import Welcome from './pages/Welcome';
import OwnerDashboard from './pages/OwnerDashboard';
import OwnerPayments from './pages/OwnerPayments';
import SpLicenseReporting from './pages/SpLicenseReporting';
import Quotes from './pages/Quotes';
import NewQuote from './pages/NewQuote';
import SpQuote from './modules/sp-quote';
import SpQuoteLogsPage from './modules/sp-quote/SpQuoteLogsPage';
import OrderInbox from './pages/OrderInbox';
import InkManager from './pages/InkManager';
import InkInventory from './pages/InkInventory';
import ThreadManager from './pages/ThreadManager';
import ImportThreads from './pages/ImportThreads';
import UpdateThreadInventory from './pages/UpdateThreadInventory';
import ProductionDashboard from './pages/ProductionDashboard';
import Login from './pages/Login';
import DropboxCallback from './pages/DropboxCallback';
import OrderTracker from './pages/OrderTracker';
import { AuthProvider } from './context/AuthContext';
import { FacilityProvider } from './context/FacilityContext';
import ProtectedRoute from './components/ProtectedRoute';

function App() {
  return (
    <AuthProvider>
    <FacilityProvider>
    <FacilityThemeProviders>
      <div className="min-h-screen flex flex-col">
          <Routes>
            <Route path="/login" element={<Login />} />

            {/* Public customer order tracker (no nav link – share link only) */}
            <Route path="/track/:slug" element={<OrderTracker />} />
            
            {/* OAuth Callback Routes */}
            <Route path="/auth/dropbox/callback" element={<DropboxCallback />} />
            
            {/* Protected Routes */}
            <Route path="/" element={
              <ProtectedRoute>
                <Navbar />
                <main className="flex-1 pt-[60px]">
                  <Welcome />
                </main>
              </ProtectedRoute>
            } />
            
            <Route path="/dashboard" element={
              <ProtectedRoute>
                <Navbar />
                <main className="flex-1 pt-[60px]">
                  <ProductionDashboard />
                </main>
              </ProtectedRoute>
            } />
            
            <Route path="/printlist" element={
              <ProtectedRoute>
                <Navbar />
                <main className="flex-1 pt-[60px]">
                  <PrintList />
                </main>
              </ProtectedRoute>
            } />

            {/* URL-only experimental v2 (not in navbar) */}
            <Route path="/printlist2" element={
              <ProtectedRoute>
                <Navbar />
                <main className="flex-1 pt-[60px]">
                  <PrintList2 />
                </main>
              </ProtectedRoute>
            } />
            
            <Route path="/screenlist" element={
              <ProtectedRoute>
                <Navbar />
                <main className="flex-1 pt-[60px]">
                  <ScreenList />
                </main>
              </ProtectedRoute>
            } />

            <Route path="/screenlist2" element={
              <ProtectedRoute>
                <Navbar />
                <main className="flex-1 pt-[60px]">
                  <ScreenList2 />
                </main>
              </ProtectedRoute>
            } />
            
            <Route path="/film-list" element={
              <ProtectedRoute>
                <Navbar />
                <main className="flex-1 pt-[60px]">
                  <FilmList />
                </main>
              </ProtectedRoute>
            } />
            
            <Route path="/ordering" element={
              <ProtectedRoute>
                <Navbar />
                <main className="flex-1 pt-[60px]">
                  <OrderingDashboard />
                </main>
              </ProtectedRoute>
            } />
            
            <Route path="/api-ordering" element={
              <ProtectedRoute>
                <Navbar />
                <main className="flex-1 pt-[60px]">
                  <APIOrdering />
                </main>
              </ProtectedRoute>
            } />
            
            <Route path="/receiving" element={
              <ProtectedRoute>
                <Navbar />
                <main className="flex-1 pt-[60px]">
                  <ReceivingDashboard />
                </main>
              </ProtectedRoute>
            } />
            
            <Route path="/receiving/api" element={
              <ProtectedRoute>
                <Navbar />
                <main className="flex-1 pt-[60px]">
                  <APIReceiving />
                </main>
              </ProtectedRoute>
            } />
            
            <Route path="/customers" element={
              <ProtectedRoute>
                <Navbar />
                <main className="flex-1 pt-[60px]">
                  <Customers />
                </main>
              </ProtectedRoute>
            } />
            
            <Route path="/orders" element={
              <ProtectedRoute>
                <Navbar />
                <main className="flex-1 pt-[60px]">
                  <Orders />
                </main>
              </ProtectedRoute>
            } />
            
            <Route path="/orders/new" element={
              <ProtectedRoute>
                <Navbar />
                <main className="flex-1 pt-[60px]">
                  <NewOrder2 />
                </main>
              </ProtectedRoute>
            } />
            
            <Route path="/order-inbox" element={
              <ProtectedRoute>
                <Navbar />
                <main className="flex-1 pt-[60px]">
                  <OrderInbox />
                </main>
              </ProtectedRoute>
            } />

            <Route path="/quotes" element={
              <ProtectedRoute>
                <Navbar />
                <main className="flex-1 pt-[60px]">
                  <Quotes />
                </main>
              </ProtectedRoute>
            } />
            
            <Route path="/quotes/new" element={
              <ProtectedRoute>
                <Navbar />
                <main className="flex-1 pt-[60px]">
                  <NewQuote />
                </main>
              </ProtectedRoute>
            } />

            {/* Temporary 3rd-party quote helper — public (no login). Strip via src/modules/sp-quote/ */}
            <Route path="/sp-quote" element={
              <main className="flex-1 min-h-screen">
                <SpQuote />
              </main>
            } />

            {/* Staff-only SP Quote usage log — not linked in nav */}
            <Route path="/sp-quote-logs" element={
              <ProtectedRoute>
                <Navbar />
                <main className="flex-1 pt-[60px]">
                  <SpQuoteLogsPage />
                </main>
              </ProtectedRoute>
            } />
            
            <Route path="/products" element={
              <ProtectedRoute>
                <Navbar />
                <main className="flex-1 pt-[60px]">
                  <Products />
                </main>
              </ProtectedRoute>
            } />
            
            <Route path="/lines" element={
              <ProtectedRoute>
                <Navbar />
                <main className="flex-1 pt-[60px]">
                  <Lines />
                </main>
              </ProtectedRoute>
            } />
            
            <Route path="/quick-order" element={
              <ProtectedRoute>
                <Navbar />
                <main className="flex-1 pt-[60px]">
                  <QuickOrder />
                </main>
              </ProtectedRoute>
            } />
            
            <Route path="/quick-order-checkout" element={
              <ProtectedRoute>
                <Navbar />
                <main className="flex-1 pt-[60px]">
                  <QuickOrderCheckout />
                </main>
              </ProtectedRoute>
            } />
            
            <Route path="/order-confirmation" element={
              <ProtectedRoute>
                <Navbar />
                <main className="flex-1 pt-[60px]">
                  <OrderConfirmation />
                </main>
              </ProtectedRoute>
            } />
            
            <Route path="/invoicing" element={
              <ProtectedRoute>
                <Navbar />
                <main className="flex-1 pt-[60px]">
                  <Invoicing />
                </main>
              </ProtectedRoute>
            } />
            
            <Route path="/archive" element={
              <ProtectedRoute>
                <Navbar />
                <main className="flex-1 pt-[60px]">
                  <Archive />
                </main>
              </ProtectedRoute>
            } />

            <Route path="/ink-manager" element={
              <ProtectedRoute>
                <Navbar />
                <main className="flex-1 pt-[60px]">
                  <InkManager />
                </main>
              </ProtectedRoute>
            } />

            <Route path="/ink-inventory" element={
              <ProtectedRoute>
                <Navbar />
                <main className="flex-1 pt-[60px]">
                  <InkInventory />
                </main>
              </ProtectedRoute>
            } />

            <Route path="/thread-manager" element={
              <ProtectedRoute>
                <Navbar />
                <main className="flex-1 pt-[60px]">
                  <ThreadManager />
                </main>
              </ProtectedRoute>
            } />

            <Route path="/import-threads" element={
              <ProtectedRoute>
                <Navbar />
                <main className="flex-1 pt-[60px]">
                  <ImportThreads />
                </main>
              </ProtectedRoute>
            } />

            <Route path="/update-thread-inventory" element={
              <ProtectedRoute>
                <Navbar />
                <main className="flex-1 pt-[60px]">
                  <UpdateThreadInventory />
                </main>
              </ProtectedRoute>
            } />
            
            <Route path="/production" element={
              <ProtectedRoute>
                <Navbar />
                <main className="flex-1 pt-[60px]">
                  <ProductionDashboard />
                </main>
              </ProtectedRoute>
            } />

            <Route path="/productiondashboard" element={
              <ProtectedRoute>
                <Navbar />
                <main className="flex-1 pt-[60px]">
                  <ProductionDashboard />
                </main>
              </ProtectedRoute>
            } />

            <Route path="/owner" element={
              <>
                <Navbar />
                <main className="flex-1 pt-[60px]">
                  <OwnerDashboard />
                </main>
              </>
            } />

            <Route path="/owner/payments" element={
              <>
                <Navbar />
                <main className="flex-1 pt-[60px]">
                  <OwnerPayments />
                </main>
              </>
            } />

            {/* Hidden: Strawberry Patch CLC royalty file. No nav link. */}
            <Route path="/splicensereporting" element={
              <ProtectedRoute>
                <Navbar />
                <main className="flex-1 pt-[60px]">
                  <SpLicenseReporting />
                </main>
              </ProtectedRoute>
            } />
          </Routes>
      </div>
    </FacilityThemeProviders>
    </FacilityProvider>
    </AuthProvider>
  );
}

export default App; 